import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import Callback from './pages/Callback';
import Dashboard from './pages/Dashboard';
import CompleteProfile from './pages/CompleteProfile';
import AdminHierarchy from './pages/AdminHierarchy';
import SsoSyncCallback from './pages/SsoSyncCallback';
import Register from './pages/Register';
import VerifyEmailCallback from './pages/VerifyEmailCallback';
import AddPhone from './pages/AddPhone';
import AddEmail from './pages/AddEmail';
import SetupPasskey from './pages/SetupPasskey';
import ManagePasskeys from './pages/ManagePasskeys';
import AdminUsers from './pages/AdminUsers';
import AdminUserDetail from './pages/AdminUserDetail';
import AdminGroups from './pages/AdminGroups';
import AdminGroupDetail from './pages/AdminGroupDetail';
import ConfirmEmail from './pages/ConfirmEmail';
import AdminApprovals from './pages/AdminApprovals';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import ChangePasswordRequired from './pages/ChangePasswordRequired';
import ClaimAccount from './pages/ClaimAccount';
import AdminBulkUsers from './pages/AdminBulkUsers';
import ResumeRegistration from './pages/ResumeRegistration';
import AdminApps from './pages/AdminApps';
import AdminAppProvisioning from './pages/AdminAppProvisioning';
import AdminAuditLog from './pages/AdminAuditLog';
import AdminActiveSessions from './pages/AdminActiveSessions';
import AdminAppUsage from './pages/AdminAppUsage';
import AdminSsoStats from './pages/AdminSsoStats';
import UserActivity from './pages/UserActivity';
import ScrollToTop from './components/ScrollToTop';
import IdleTimeoutWatcher from './components/IdleTimeoutWatcher';
import TabPresenceWatcher from './components/TabPresenceWatcher';
import AccountCompletionGuard from './components/AccountCompletionGuard';
import MfaSetupRequired from './pages/MfaSetupRequired';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <IdleTimeoutWatcher />
        <TabPresenceWatcher />
        <AccountCompletionGuard />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/callback" element={<Callback />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/complete-profile" element={<CompleteProfile />} />
          <Route path="/admin/hierarchy" element={<AdminHierarchy />} />
          <Route path="/sso-sync-callback" element={<SsoSyncCallback />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmailCallback />} />
          <Route path="/add-phone" element={<AddPhone />} />
          <Route path="/add-email" element={<AddEmail />} />
          <Route path="/setup-passkey" element={<SetupPasskey />} />
          <Route path="/manage-passkeys" element={<ManagePasskeys />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/users/:pk" element={<AdminUserDetail />} />
          <Route path="/admin/groups" element={<AdminGroups />} />
          <Route path="/admin/groups/:pk" element={<AdminGroupDetail />} />
          <Route path="/confirm-email" element={<ConfirmEmail />} />
          <Route path="/admin/approvals" element={<AdminApprovals />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/change-password" element={<ChangePasswordRequired />} />
          <Route path="/setup-mfa" element={<MfaSetupRequired />} />
          <Route path="/claim-account" element={<ClaimAccount />} />
          <Route path="/admin/bulk-users" element={<AdminBulkUsers />} />
          <Route path="/admin/apps" element={<AdminApps />} />
          <Route path="/admin/app-provisioning" element={<AdminAppProvisioning />} />
          <Route path="/admin/audit-log" element={<AdminAuditLog />} />
          <Route path="/admin/active-sessions" element={<AdminActiveSessions />} />
          <Route path="/admin/app-usage" element={<AdminAppUsage />} />
          <Route path="/admin/sso-stats" element={<AdminSsoStats />} />
          <Route path="/admin/user-activity" element={<UserActivity />} />
          <Route path="/resume-registration" element={<ResumeRegistration />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;